module.exports = __webpack_public_path__ + "img/bar.6c6a0b13.svg";